import { render, staticRenderFns } from "./Lec5.vue?vue&type=template&id=61179f58&scoped=true&lang=pug&"
import script from "./Lec5.vue?vue&type=script&lang=ts&"
export * from "./Lec5.vue?vue&type=script&lang=ts&"
import style0 from "./Lec5.vue?vue&type=style&index=0&id=61179f58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61179f58",
  null
  
)

export default component.exports